export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moneda"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crear informe"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Resultado de moneda"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descargar"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Hoja"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Formato de archivo permitido - xlsx"])}
}